const historicoInitialState = {
    historico: {
        loading: false,
        error: null,
        data: null
    },
};

export default historicoInitialState;